import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { Device } from '@era/locations-sdk';
import {
  deviceAllowedToAssign,
  deviceAllowedToAssignToBar,
  deviceAllowedToAssignToFrontDesk,
  deviceAllowedToAssignToHousekeeping,
  deviceAllowedToAssignToKiosk,
  deviceAllowedToAssignToStaff,
  deviceAllowedToMarkAsSpare,
  deviceAllowedToMarkUnavailable,
  deviceAllowedToUnassign,
} from '@era/stores';
import { EnvironmentService } from '@methylium/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceActionBarComponent } from '@rocksoft/cdk';
import { AssignmentHistoryModalComponent } from '../../sub-features/device-assignment/assignment-history/assignment-history-component/assignment-history-modal.container';
import { NotesModalComponent } from '../../sub-features/device-notes/notes-modal/notes-modal.container';

@Component({
  selector: 'era-device-action-bar',
  templateUrl: './device-action-bar.container.html',
  styleUrls: ['./device-action-bar.container.scss'],
  imports: [DeviceActionBarComponent],
})
export class DeviceActionBarContainerComponent implements OnInit, OnChanges {
  public allowUnassign: boolean;
  public allowUnavailable: boolean;
  public allowAssign: boolean;
  public allowSpare: boolean;
  public allowHousekeeping: boolean;
  public allowStaff: boolean;
  public allowFrontDesk: boolean;
  public allowBar: boolean;
  public allowKiosk: boolean;
  @Input() public device: Device;
  public readonly notesEnabled: boolean = true;
  public readonly assignmentHistoryEnabled: boolean = true;

  constructor(
    private readonly environmentService: EnvironmentService,
    private readonly modalService: NgbModal
  ) {
    this.notesEnabled = this.environmentService.environment.features.devices.notes.enabled;
    this.assignmentHistoryEnabled = this.environmentService.environment.features.devices.assignmentHistory.enabled;
  }

  ngOnChanges(): void {
    this.recalculate();
  }

  ngOnInit(): void {
    this.recalculate();
  }

  private recalculate() {
    this.allowUnassign = deviceAllowedToUnassign(this.device);

    this.allowUnavailable = deviceAllowedToMarkUnavailable(this.device);

    this.allowSpare = deviceAllowedToMarkAsSpare(this.device);

    this.allowAssign = deviceAllowedToAssign(this.device);

    this.allowHousekeeping = deviceAllowedToAssignToHousekeeping(this.device);

    this.allowStaff = deviceAllowedToAssignToStaff(this.device);

    this.allowFrontDesk = deviceAllowedToAssignToFrontDesk(this.device);

    this.allowBar = deviceAllowedToAssignToBar(this.device);

    this.allowKiosk = deviceAllowedToAssignToKiosk(this.device);
  }

  openNotesModal() {
    this.modalService.open(NotesModalComponent, { backdrop: 'static', centered: true, size: 'lg', scrollable: true });
  }

  openAssignmentHistoryModal() {
    this.modalService.open(AssignmentHistoryModalComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
      scrollable: true,
    });
  }
}
